import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import warning_yellow_icon from '../../../asset/img/common/warning_yellow_icon.svg';
import Typography from '../../../components/common/Typography';

import InfoBanner from '../../../components/Banner';
import ResultMessageBox from './ResultMessageBox';

import AuthenticationSection from './AuthenticationSection';
import Signature from './AuthenticationModal/signature';
import SMS from './AuthenticationModal/SMS';
import Kakao from './AuthenticationModal/kakao';
import Email from './AuthenticationModal/Email';
import SlideDialogV from '../../../components/common/SlideDialogV';
import { getAlertMessageFunction, magamCertifyCheck } from '../../../common/Util';
import { isValidatePhoneEmail } from '../util';

//인증전
const BeforeAuthentication = ({ handleAuthentication }) => {
  const { t } = useTranslation('resultQuery');
  const { t: tCommon } = useTranslation('common');
  const { isMagam, isCertify } = useSelector(state => state.common);
  const { myInfo } = useSelector(state => state.myInfo);
  //1 : signature, 2 : SMS, 3: email 4: kakao
  const [isModalOpen, setIsModalOpen] = useState(0);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [pendingModalType, setPendingModalType] = useState(0);

  const modalOpenHandler = modalType => {
    const alertMessage = getAlertMessageFunction();
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    const { htmInsaPerHTel, htmInsaPerEMail } = myInfo;
    const value = modalType === 3 ? htmInsaPerEMail : htmInsaPerHTel;

    // 휴대전화번호, 이메일 유효성 검사
    const validation = isValidatePhoneEmail(modalType, value);
    if (!validation.isValid) {
      alertMessage(tCommon(validation.messageKey));
      return;
    }

    // 컨펌 다이얼로그 열기
    setPendingModalType(modalType);
    setIsConfirmDialogOpen(true);
  };

  const handleConfirmSubmit = () => {
    setIsConfirmDialogOpen(false);
    setIsModalOpen(pendingModalType);
    setPendingModalType(0);
  };

  const handleConfirmCancel = () => {
    setIsConfirmDialogOpen(false);
    setPendingModalType(0);
  };

  const modalCloseHandler = () => {
    setIsModalOpen(0);
  };

  const renderModal = () => {
    if (isModalOpen === 1)
      return <Signature modalCloseHandler={modalCloseHandler} {...{ handleAuthentication }} />;
    if (isModalOpen === 2)
      return (
        <SMS
          modalCloseHandler={modalCloseHandler}
          htmSendUrlType="LMS"
          isOpen={isModalOpen == 2}
          {...{ handleAuthentication }}
        />
      );
    if (isModalOpen === 3)
      return (
        <SMS
          modalCloseHandler={modalCloseHandler}
          htmSendUrlType="email"
          isOpen={isModalOpen == 3}
          {...{ handleAuthentication }}
        />
      );
    if (isModalOpen === 4)
      return (
        <Kakao
          modalCloseHandler={modalCloseHandler}
          isOpen={isModalOpen == 4}
          {...{ handleAuthentication }}
        />
      );
  };

  return (
    <>
      <InfoBanner title={t('bannerSection.title')} />
      {/* 결과 예상 */}
      <ResultMessageBox />

      <div className="displayFlex" style={{ gap: '4px', justifyContent: 'center' }}>
        <img src={warning_yellow_icon} alt={t('expectedResultMessage')} />
        <Typography variant="body2Medium" color="Warning-500">
          {t('expectedResultMessage')}
        </Typography>
      </div>
      {/* 서명 */}
      <AuthenticationSection modalOpenHandler={modalOpenHandler} />

      {/* 모달 */}
      {renderModal()}

      {/* 제출 확인 다이얼로그 */}
      <SlideDialogV
        isOpen={isConfirmDialogOpen}
        onClose={handleConfirmCancel}
        title={t('confirmDialog.title')}
        description={t('confirmDialog.description')}
        buttons={[
          {
            label: t('confirmDialog.submitButton'),
            onClick: handleConfirmSubmit,
            color: 'primary',
          },
          {
            label: t('confirmDialog.cancelButton'),
            onClick: handleConfirmCancel,
            color: 'secondary',
          },
        ]}
      />
    </>
  );
};

export default BeforeAuthentication;
